<template>
  <div class="history-booking">
    <div class="box-bill" @click="getDetailBooked(objectData)">
      <div class="header-bill">
        <div class="icon-sale-container">
          <div class="flex-shrink-0">
            <img
              :src="objectData.img_logo || icons.Logo"
              alt=""
              class="image-facility"
            />
          </div>
          <div style="padding-left: 8px; margin-right:10px">
            <div class="course-name">
              {{ objectData?.Booking_Pax?.facility?.title }}
            </div>
            <div class="teetime fw-cv2">
              Teetime: {{ objectData?.Booking_Pax?.date_played }}
            </div>
          </div>
        </div>
      </div>
      <div class="body-bill">
        <div class="full-width">
          <div class="flex align-items-center mb-3">
            <img :src="icons.Money" alt="" />
            <span style="padding-left: 10px; font-size: 12px">
              {{ $t("amountToPay") }}
            </span>
            <div style="padding-left: 5px" class="c-text-price c-tiny fw-cv1">
              {{ formatNumber(objectData.price_booking) }} đ
            </div>
          </div>
          <div class="flex align-items-center mb-3">
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="9" cy="9" r="9" fill="#E5E6EB" />
              <path
                d="M11.8631 4.5H6.13624C6.03822 4.50113 5.94387 4.53742 5.87035 4.60227C6.16207 4.7049 6.41873 4.8881 6.61059 5.13064C6.80244 5.37317 6.92164 5.66511 6.95436 5.97262C6.96062 6.02698 6.96062 6.08188 6.95436 6.13624V13.0903C6.95417 13.1685 6.97642 13.2452 7.01847 13.3111C7.06052 13.3771 7.12061 13.4297 7.19162 13.4625C7.26279 13.4953 7.34187 13.5069 7.41947 13.496C7.49706 13.4852 7.56989 13.4522 7.62931 13.4012L8.79514 12.403L9.96096 13.4012C10.0351 13.4645 10.1293 13.4994 10.2268 13.4994C10.3243 13.4994 10.4186 13.4645 10.4927 13.4012L11.6586 12.403L12.8244 13.4012C12.8985 13.4645 12.9928 13.4993 13.0903 13.4993C13.1495 13.4989 13.2079 13.4864 13.2621 13.4625C13.3331 13.4297 13.3932 13.3771 13.4352 13.3111C13.4773 13.2452 13.4995 13.1685 13.4993 13.0903V6.13624C13.4993 5.70228 13.3269 5.2861 13.0201 4.97924C12.7132 4.67239 12.297 4.5 11.8631 4.5ZM11.454 10.2268H8.99967C8.89118 10.2268 8.78713 10.1838 8.71042 10.107C8.6337 10.0303 8.59061 9.92628 8.59061 9.81779C8.59061 9.7093 8.6337 9.60525 8.71042 9.52854C8.78713 9.45182 8.89118 9.40873 8.99967 9.40873H11.454C11.5625 9.40873 11.6666 9.45182 11.7433 9.52854C11.82 9.60525 11.8631 9.7093 11.8631 9.81779C11.8631 9.92628 11.82 10.0303 11.7433 10.107C11.6666 10.1838 11.5625 10.2268 11.454 10.2268ZM11.454 8.59061H8.99967C8.89118 8.59061 8.78713 8.54751 8.71042 8.47079C8.6337 8.39408 8.59061 8.29003 8.59061 8.18155C8.59061 8.07306 8.6337 7.96901 8.71042 7.8923C8.78713 7.81558 8.89118 7.77248 8.99967 7.77248H11.454C11.5625 7.77248 11.6666 7.81558 11.7433 7.8923C11.82 7.96901 11.8631 8.07306 11.8631 8.18155C11.8631 8.29003 11.82 8.39408 11.7433 8.47079C11.6666 8.54751 11.5625 8.59061 11.454 8.59061ZM11.454 6.95436H8.99967C8.89118 6.95436 8.78713 6.91127 8.71042 6.83455C8.6337 6.75784 8.59061 6.65379 8.59061 6.5453C8.59061 6.43681 8.6337 6.33277 8.71042 6.25605C8.78713 6.17934 8.89118 6.13624 8.99967 6.13624H11.454C11.5625 6.13624 11.6666 6.17934 11.7433 6.25605C11.82 6.33277 11.8631 6.43681 11.8631 6.5453C11.8631 6.65379 11.82 6.75784 11.7433 6.83455C11.6666 6.91127 11.5625 6.95436 11.454 6.95436ZM6.13624 6.13624V9.40873H4.90906C4.80057 9.40873 4.69652 9.36563 4.61981 9.28892C4.5431 9.2122 4.5 9.10816 4.5 8.99967V6.13624C4.5 6.07897 4.5 6.0258 4.5 5.97262C4.5217 5.75564 4.6287 5.55617 4.79747 5.41808C4.96624 5.28 5.18295 5.21461 5.39993 5.23631C5.61691 5.25801 5.81639 5.36501 5.95447 5.53378C6.09255 5.70255 6.15794 5.91926 6.13624 6.13624Z"
                fill="black"
              />
            </svg>
            <span
              class="c-medium-text"
              style="padding-left: 10px; font-size: 12px"
            >
              {{ $t("billCode") }}
            </span>
            <div style="padding-left: 5px" class="text2 fw-cv1">
              {{ objectData?.general_bill_code }}
            </div>
          </div>
          <div class="flex align-items-center mb-3">
            <img :src="icons.Teetime" alt="" />
            <span
              class="c-medium-text"
              style="padding-left: 10px; font-size: 12px"
            >
              {{ $t("paymentCode") }}
            </span>
            <div style="padding-left: 5px" class="text2 fw-cv1">
              {{ objectData?.general_payment_code }}
            </div>
          </div>
          <div class="flex align-items-center mb-3">
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="9" cy="9" r="9" fill="#E5E6EB" />
              <path
                d="M13.1544 8.79543C13.3524 8.79543 13.5509 8.79543 13.7489 8.79543C13.7928 8.79543 13.8379 8.79543 13.8801 8.80433C13.9824 8.82657 14.0302 8.92664 13.9797 9.01782C13.9546 9.06285 13.9157 9.10121 13.8785 9.1379C13.5114 9.49983 13.1461 9.86287 12.7745 10.2198C12.5938 10.3932 12.526 10.5895 12.5727 10.8391C12.6733 11.3751 12.7595 11.9138 12.8563 12.4509C13.0037 13.2697 12.372 14.0153 11.54 13.9953C11.3348 13.9903 11.1418 13.9336 10.9588 13.8374C10.4761 13.5827 9.98898 13.3359 9.50849 13.0774C9.2816 12.9551 9.06972 12.959 8.84505 13.0813C8.36512 13.3415 7.88185 13.595 7.39747 13.8469C6.61891 14.2527 5.69576 13.8163 5.51558 12.9584C5.46831 12.7344 5.4989 12.512 5.53782 12.2896C5.62291 11.8043 5.70522 11.3183 5.78807 10.833C5.827 10.6034 5.76361 10.4116 5.59232 10.2476C5.19081 9.86453 4.79429 9.47648 4.39723 9.08842C4.12028 8.81879 3.98904 8.48688 4.00072 8.10216C4.01907 7.49951 4.47341 6.97468 5.0679 6.87795C5.59344 6.79233 6.12119 6.7195 6.64783 6.64111C6.69121 6.63444 6.73458 6.6261 6.77796 6.62054C7.02043 6.59107 7.17726 6.45487 7.27179 6.23526C7.44753 5.82719 7.62493 5.41967 7.80233 5.01216C7.85461 4.89096 7.91077 4.77143 7.95915 4.64857C8.08984 4.31944 8.3312 4.11985 8.6721 4.04146C9.06416 3.9514 9.43675 4.00422 9.7682 4.23772C9.86941 4.30888 9.95784 4.41173 10.0229 4.51792C10.3905 5.11891 10.7492 5.72489 11.1107 6.32922C11.2074 6.49156 11.352 6.58273 11.5367 6.60942C12.1072 6.6917 12.6784 6.77176 13.249 6.85293C13.3012 6.86015 13.3552 6.86571 13.4041 6.88351C13.5186 6.92409 13.5464 7.04973 13.4636 7.13925C13.4397 7.16482 13.4107 7.18539 13.3835 7.20763C13.1021 7.43446 12.8185 7.65739 12.5404 7.88811C12.3164 8.07381 12.0627 8.14608 11.7775 8.10661C11.3981 8.05435 11.0194 7.99764 10.6402 7.94371C10.3999 7.9098 10.2287 7.78471 10.1147 7.56955C9.83215 7.03695 9.54408 6.50713 9.25824 5.97619C9.24156 5.94505 9.2271 5.91225 9.20597 5.88445C9.15036 5.80996 9.06138 5.80885 9.00744 5.88334C8.98464 5.91503 8.97073 5.95339 8.95405 5.98897C8.72103 6.50157 8.48357 7.01249 8.25668 7.52841C8.14434 7.78415 7.95804 7.9148 7.68443 7.95261C7.10051 8.03322 6.5177 8.1244 5.93434 8.21168C5.90819 8.21557 5.88095 8.21669 5.85648 8.22558C5.76861 8.25727 5.74192 8.34067 5.79697 8.41572C5.82256 8.45074 5.85703 8.47965 5.88873 8.51023C6.30248 8.91219 6.71623 9.31469 7.1311 9.71554C7.25233 9.83229 7.34465 9.96517 7.35521 10.1364C7.36077 10.2276 7.35076 10.321 7.33575 10.411C7.23954 10.9881 7.13999 11.5647 7.04045 12.1412C7.02988 12.2012 7.02655 12.2551 7.07937 12.2969C7.13833 12.3435 7.19505 12.3202 7.25177 12.2902C7.65273 12.0783 8.05314 11.866 8.45409 11.6541C8.57866 11.588 8.70491 11.5257 8.82725 11.4557C9.06583 11.3189 9.29828 11.3211 9.54186 11.4523C10.0535 11.7275 10.5701 11.9939 11.0851 12.2629C11.1496 12.2969 11.2141 12.3502 11.292 12.2929C11.3698 12.2357 11.3381 12.1606 11.3253 12.0873C11.223 11.4935 11.1218 10.8992 11.0184 10.3054C10.9816 10.0947 11.0334 9.91068 11.183 9.76002C11.4121 9.52874 11.6434 9.29857 11.8792 9.07341C12.0683 8.89273 12.2974 8.79988 12.5599 8.79599C12.7579 8.79321 12.9564 8.79543 13.1544 8.79543Z"
                fill="black"
              />
            </svg>
            <span
              class="c-medium-text"
              style="padding-left: 10px; font-size: 12px"
            >
              {{ objectData?.is_hio == 1 ? $t("yes") : $t("no") }}
            </span>
          </div>
          <div class="flex align-items-center mb-3">
            <img :src="icons.Clock" alt="" />
            <span
              class="c-medium-text"
              style="padding-left: 10px; font-size: 12px"
            >
              {{ $t("orderStatus") }}
            </span>
            <p style="padding-left: 5px;" class="text3 m-0">
              <span
                :style="{
                  color:
                    objectData?.general_status !== 1
                      ? 'red'
                      : 'rgba(27, 200, 139, 1)'
                }"
                class="ml-1 m-0 fw-cv1"
                style="font-size: 12px"
              >
                {{ STATUS_BILL[objectData?.general_status] }}
              </span>
            </p>
          </div>
          <div class="flex align-items-center mb-3">
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="9" cy="9" r="9" fill="#E5E6EB" />
              <path
                d="M11.8631 4.5H6.13624C6.03822 4.50113 5.94387 4.53742 5.87035 4.60227C6.16207 4.7049 6.41873 4.8881 6.61059 5.13064C6.80244 5.37317 6.92164 5.66511 6.95436 5.97262C6.96062 6.02698 6.96062 6.08188 6.95436 6.13624V13.0903C6.95417 13.1685 6.97642 13.2452 7.01847 13.3111C7.06052 13.3771 7.12061 13.4297 7.19162 13.4625C7.26279 13.4953 7.34187 13.5069 7.41947 13.496C7.49706 13.4852 7.56989 13.4522 7.62931 13.4012L8.79514 12.403L9.96096 13.4012C10.0351 13.4645 10.1293 13.4994 10.2268 13.4994C10.3243 13.4994 10.4186 13.4645 10.4927 13.4012L11.6586 12.403L12.8244 13.4012C12.8985 13.4645 12.9928 13.4993 13.0903 13.4993C13.1495 13.4989 13.2079 13.4864 13.2621 13.4625C13.3331 13.4297 13.3932 13.3771 13.4352 13.3111C13.4773 13.2452 13.4995 13.1685 13.4993 13.0903V6.13624C13.4993 5.70228 13.3269 5.2861 13.0201 4.97924C12.7132 4.67239 12.297 4.5 11.8631 4.5ZM11.454 10.2268H8.99967C8.89118 10.2268 8.78713 10.1838 8.71042 10.107C8.6337 10.0303 8.59061 9.92628 8.59061 9.81779C8.59061 9.7093 8.6337 9.60525 8.71042 9.52854C8.78713 9.45182 8.89118 9.40873 8.99967 9.40873H11.454C11.5625 9.40873 11.6666 9.45182 11.7433 9.52854C11.82 9.60525 11.8631 9.7093 11.8631 9.81779C11.8631 9.92628 11.82 10.0303 11.7433 10.107C11.6666 10.1838 11.5625 10.2268 11.454 10.2268ZM11.454 8.59061H8.99967C8.89118 8.59061 8.78713 8.54751 8.71042 8.47079C8.6337 8.39408 8.59061 8.29003 8.59061 8.18155C8.59061 8.07306 8.6337 7.96901 8.71042 7.8923C8.78713 7.81558 8.89118 7.77248 8.99967 7.77248H11.454C11.5625 7.77248 11.6666 7.81558 11.7433 7.8923C11.82 7.96901 11.8631 8.07306 11.8631 8.18155C11.8631 8.29003 11.82 8.39408 11.7433 8.47079C11.6666 8.54751 11.5625 8.59061 11.454 8.59061ZM11.454 6.95436H8.99967C8.89118 6.95436 8.78713 6.91127 8.71042 6.83455C8.6337 6.75784 8.59061 6.65379 8.59061 6.5453C8.59061 6.43681 8.6337 6.33277 8.71042 6.25605C8.78713 6.17934 8.89118 6.13624 8.99967 6.13624H11.454C11.5625 6.13624 11.6666 6.17934 11.7433 6.25605C11.82 6.33277 11.8631 6.43681 11.8631 6.5453C11.8631 6.65379 11.82 6.75784 11.7433 6.83455C11.6666 6.91127 11.5625 6.95436 11.454 6.95436ZM6.13624 6.13624V9.40873H4.90906C4.80057 9.40873 4.69652 9.36563 4.61981 9.28892C4.5431 9.2122 4.5 9.10816 4.5 8.99967V6.13624C4.5 6.07897 4.5 6.0258 4.5 5.97262C4.5217 5.75564 4.6287 5.55617 4.79747 5.41808C4.96624 5.28 5.18295 5.21461 5.39993 5.23631C5.61691 5.25801 5.81639 5.36501 5.95447 5.53378C6.09255 5.70255 6.15794 5.91926 6.13624 6.13624Z"
                fill="black"
              />
            </svg>
            <div style="padding-left: 10px" class="text2 cursor-pointer fw-cv2">
              <u>{{ $t("viewBillDetails") }}</u>
            </div>
          </div>
          <div
            v-if="
              objectData?.general_payment_code &&
                objectData?.general_status == 3
            "
            class="box-pay"
          >
            <el-button
              class="button-pay fw-cv2 fs-cv1 c-white-text bg-btn-main"
              @click="getDetailBooked(objectData)"
            >
              {{ $t("pay") }}
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Logo from "@/assets/img/svg/Logo.svg";
import Money from "@/assets/img/svg/money.svg";
import Teetime from "@/assets/img/svg/1.svg";
import GroupMember from "@/assets/img/svg/5.svg";
import Member from "@/assets/img/svg/2.svg";
import Time from "@/assets/img/svg/3.svg";
import Clock from "@/assets/img/svg/clock.svg";
import { formatNumber } from "@/plugins/init";
import { STATUS_BILL } from "@/constant/contant";

export default {
  components: {},
  props: {
    objectData: {
      type: Object,
      default() {
        return {};
      }
    },
    status: {
      type: Object,
      default() {
        return {};
      }
    },
    isActive: {
      type: Number,
      default() {
        return 0;
      }
    }
  },

  created() {},
  data() {
    return {
      STATUS_BILL: STATUS_BILL,
      icons: {
        Logo,
        Money,
        Teetime,
        GroupMember,
        Member,
        Time,
        Clock
      }
    };
  },
  watch: {},
  methods: {
    formatNumber,
    getDetailBooked(objectData) {
      this.$router.push(
        `/wap/detail-history-booked/${objectData?.Booking_Pax?.id_general_bill_detail}?status=${objectData?.general_status}&type=${this.isActive}`
      );
    }
  }
};
</script>

<style lang="scss">
.history-booking {
  .image-facility {
    width: 32px;
    height: 32px;
    border-radius: 50%;
  }
  .text3 {
    color: var(--red, #f00);
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
  .text2 {
    color: var(--icon, #090710);
    font-size: 12px;
    font-style: normal;
    line-height: normal;
  }
  .button-pay {
    position: absolute;
    right: 10px;
    bottom: 10px;
    padding: 8px 20px;
    border-radius: 5px;
  }
  .body-bill {
    width: 100%;
    padding: 10px 10px 8px 18px;
    position: relative;
    overflow: hidden;
  }
  .course-name {
    color: #1c1c1c;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .teetime {
    color: #686868;
    font-size: 12px;
    font-style: normal;
    line-height: normal;
    margin-top: 4px;
  }
  .header-bill {
    display: flex;
    position: relative;
  }
  .icon-sale-container {
    top: 9px;
    left: 10px;
    position: relative;
    display: flex;
  }
  .mr-10 {
    margin-right: 10px;
  }

  .box-bill {
    border: 1px solid #f5f5f5;
    background: #ffff;
    border-radius: 5.931px;
    box-shadow: 0px 0px 3.5584840774536133px 0px rgba(0, 0, 0, 0.15);
    width: 100%;
    flex-shrink: 0;
    margin-bottom: 15px;
  }
  .text1 {
    color: #f00;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }

  .member {
    position: absolute;
    display: contents;
  }

  .desktop {
    display: block;
  }

  .mobile {
    display: none;
  }

  @media screen and (min-width: 0px) and (max-width: 480px) {
    .title-h3 {
      font-size: 14px !important;
    }
    .text-time {
      font-size: 13px;
    }

    .desktop {
      display: none;
    }
    .mobile {
      display: block;
    }
  }

  @media screen and (min-width: 0px) and (max-width: 769px) {
    .desktop {
      display: none;
    }
    .mobile {
      display: block;
    }
    .top-spacing {
      padding-top: 50px;
    }
  }
}
</style>
